// extracted by css-extract-rspack-plugin
export default {"Spinner":"lC_DtdI5imIM0bfZ","fadeIn":"xlSUa_9KPb4syzd5"};